export const contactInfo = {
  businessName: "RK Air Conditioners",
  owner: "Auth. by Rakesh Kumar",
  tagline: "Your trusted partner for AC service, repair, installation, rental and appliance care.",
  primaryPhone: "+91-98101-92110",
  secondaryPhone: "+91-88821-40953",
  primaryPhoneHref: "tel:+919810192110",
  secondaryPhoneHref: "tel:+918882140953",
  whatsappHref:
    "https://wa.me/919810192110?text=Hello%20RK%20Air%20Conditioners%2C%20I%20need%20AC%20service%20or%20repair.",
  emails: ["info@rkairconditioners.com", "Rakeshacservice@gmail.com"],
  address:
    "H.No.39, New MS Block, Dwarka Mor Metro Station, Mohan Garden, Uttam Nagar, New Delhi-110059.",
  social: {
    youtube: "https://www.youtube.com/@RK_Air_Conditioners",
    facebook: "https://www.facebook.com/profile.php?id=100092160535674",
    instagram: "https://instagram.com/rkairconditioners",
  },
};

export const media = {
  logo:
    "https://customer-assets.emergentagent.com/job_rk-air-pro/artifacts/e44oum5z_rk.webp",
  heroBackground:
    "https://static.prod-images.emergentagent.com/jobs/1010184d-fb2b-4bff-b994-fb759545e007/images/5034c191688fe9b3749a932d5a7ac90e958c90af1603c75308e127f40189dd2f.png",
  professionalAcCleaning:
    "https://static.prod-images.emergentagent.com/jobs/1010184d-fb2b-4bff-b994-fb759545e007/images/c3bb05167d4adb8b2f8bf8f4f12926801d86d0f85968b85e39dc7a97b5fecd65.png",
  premiumAc:
    "https://static.prod-images.emergentagent.com/jobs/1010184d-fb2b-4bff-b994-fb759545e007/images/eb50841f451a4ae8394252e790e7fa73b29e634193050fe9188fa29410e29dbc.png",
  repair:
    "https://images.pexels.com/photos/33671149/pexels-photo-33671149.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  installation:
    "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxhYyUyMGluc3RhbGxhdGlvbiUyMHRlY2huaWNpYW58ZW58MHx8fHwxNzc4OTU1NzU3fDA&ixlib=rb-4.1.0&q=85",
  cleaning:
    "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=765,fit=crop/YNqXqDwR3QUa1W3L/air-con-hygiene-service-in-caboolture-qld-air-conditioning-heating-installation-Aq20Xp4ewqcq2DO5.jpeg",
  appliances:
    "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=765,fit=crop,trim=0;339.74056603773585;0;10.141509433962264/YNqXqDwR3QUa1W3L/transparent-home-appliances-png---home-appliances-png-png-download-transparent-png-image---pngitem-dJoGoKvXnwCMqzaG.png",
};

export const navItems = [
  { id: "home", label: "Home" },
  { id: "services", label: "Services" },
  { id: "products", label: "Products" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export const heroStats = [
  { value: "15+", label: "Years Experience" },
  { value: "24×7", label: "On-Demand Service" },
  { value: "₹599", label: "AC Service Starts" },
];

export const trustPoints = [
  "24×7 on-demand service",
  "15+ years industry experience",
  "AC service starts at ₹599/-",
  "West Delhi local technician support",
];

export const services = [
  {
    id: "repair",
    kicker: "First of all",
    title: "Expert Repair Services",
    description:
      "Top-quality repair for ACs, TVs, refrigerators, washing machines, RO systems, microwaves and inverter-UPS units.",
    image: media.repair,
    featured: true,
    items: [
      "Window AC Repair",
      "Split AC Repair",
      "AC PCB Repair",
      "Washing Machine Repair",
      "Refrigerator Repair",
      "TV LED/LCD Repair",
      "RO & RO PCB Repair",
      "Geyser Repair",
    ],
  },
  {
    id: "cleaning",
    kicker: "Performance care",
    title: "Cleaning & Maintenance",
    description:
      "Reliable deep cleaning and maintenance to keep appliances efficient, hygienic and cooling at peak performance.",
    image: media.cleaning,
    items: [
      "Split AC Service",
      "Window AC Service",
      "RO Service / Cleaning",
      "Washing Machine Maintenance",
      "Refrigerator Maintenance",
      "Geyser Maintenance",
    ],
  },
  {
    id: "installation",
    kicker: "Setup done right",
    title: "Installation & Relocation",
    description:
      "Professional installation, uninstall and re-location for ACs, TVs, geysers, washing machines and RO systems.",
    image: media.installation,
    items: [
      "Window AC Installation",
      "Split AC Installation",
      "AC Remove / Re-install",
      "TV Wall Mount",
      "RO Installation",
      "Geyser Installation",
    ],
  },
];

export const serviceCategories = [
  {
    id: "repair-services",
    label: "First of all",
    title: "Repair Services",
    description:
      "Quick diagnosis and reliable repair for cooling, washing, display, kitchen and water-purifier appliances.",
    highlights: ["AC gas/cooling issue", "PCB repair", "Motor & compressor checks", "Same-day complaint support"],
  },
  {
    id: "cleaning-services",
    label: "Not to mention",
    title: "Cleaning Services",
    description:
      "Deep cleaning and preventive maintenance that improves cooling, hygiene, appliance life and power efficiency.",
    highlights: ["Split & window AC wash", "Filter cleaning", "RO cleaning", "Washing machine maintenance"],
  },
  {
    id: "installation-services",
    label: "Setup & relocation",
    title: "Installation Services",
    description:
      "Safe installation, uninstallation and relocation for ACs, TVs, RO systems, geysers and washing machines.",
    highlights: ["Split AC fitting", "Window AC fitting", "TV wall mount", "RO & geyser installation"],
  },
];

export const applianceServices = [
  {
    id: "fridge",
    title: "Fridge / Refrigerator",
    description:
      "Repair and maintenance for single-door, double-door, frost-free and side-by-side refrigerators.",
    problems: ["Cooling problem", "Gas leakage", "Compressor issue", "Thermostat fault", "Noise or water leakage"],
  },
  {
    id: "washing-machine",
    title: "Washing Machine",
    description:
      "Service for semi-automatic, fully-automatic top-load and front-load washing machines.",
    problems: ["Drainage issue", "Spin problem", "Motor repair", "PCB fault", "Installation & maintenance"],
  },
  {
    id: "tv",
    title: "TV LED / LCD",
    description:
      "LED/LCD TV repair, wall-mount installation, relocation and PCB-level support.",
    problems: ["No display", "Sound problem", "Backlight issue", "PCB repair", "Wall mount fitting"],
  },
  {
    id: "microwave",
    title: "Microwave Oven",
    description:
      "Microwave repair and servicing for heating, plate rotation, fuse and electrical faults.",
    problems: ["No heating", "Plate not rotating", "Fuse issue", "Door switch problem", "General servicing"],
  },
  {
    id: "ro",
    title: "RO Water Purifier",
    description:
      "RO installation, filter cleaning, servicing and PCB repair for wall-mount and under-sink units.",
    problems: ["Low water flow", "Filter change", "Pump issue", "PCB fault", "Installation / relocation"],
  },
  {
    id: "geyser",
    title: "Geyser",
    description:
      "Instant and storage geyser repair, installation, relocation and safety maintenance.",
    problems: ["No heating", "Water leakage", "Element replacement", "Installation", "Maintenance check"],
  },
];

export const productServices = [
  {
    id: "sale-purchase",
    title: "Sale & Purchase",
    description:
      "Buy or sell quality new and used electronic appliances with assured quality and warranty support.",
    items: ["Window AC", "Split AC", "Washing Machine", "Refrigerator", "LED/LCD TV", "RO", "Geyser"],
  },
  {
    id: "appliance-rental",
    title: "Appliance Rental",
    description:
      "No need to buy when you can rent ACs, TVs, fridges, washing machines and geysers at reliable prices.",
    items: ["Window AC", "Split AC", "Top Load Machine", "Front Load Machine", "Refrigerator", "TV", "Geyser"],
  },
];

export const processSteps = [
  { step: "01", title: "Call or WhatsApp", text: "Share your appliance issue and location with the service team." },
  { step: "02", title: "Technician Visit", text: "A trained technician checks the problem and explains the best fix." },
  { step: "03", title: "Service Completed", text: "Repair, cleaning or installation is completed with care and transparency." },
];

export const brands = [
  "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,h=184,fit=crop,trim=0;8.205128205128204;0;0/YNqXqDwR3QUa1W3L/lg-logo-2-mxBx9D3wXDFpWelG.png",
  "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,h=279,fit=crop,trim=0;0;488.0769230769231;0/YNqXqDwR3QUa1W3L/videocon-mk3LMr7w0yfyKLE0.png",
  "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,h=279,fit=crop,trim=0;250.23696682464455;0;0/YNqXqDwR3QUa1W3L/tcl-YZ9nprPvDLtxLnen.png",
  "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,h=132,fit=crop,trim=0;7.337579617834395;0;0/YNqXqDwR3QUa1W3L/samsung-logo-and-symbol-meaning-history-png-brand-YyvkLMBxr3iQQ4g6.png",
  "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,h=81,fit=crop,trim=0;0;0;0/YNqXqDwR3QUa1W3L/daikin-split-systems-AzGyzZRPnouel2vQ.png",
  "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,h=222,fit=crop,trim=0;0;28.248175182481752;0/YNqXqDwR3QUa1W3L/panasonic-logo-png-vector-eps-free-download-AwvLy2Qw0zSZ45ke.png",
  "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,h=205,fit=crop,trim=0;55.565891472868216;0;0/YNqXqDwR3QUa1W3L/guest-interview_-whirlpool-s-ux-manager---learn-ux-YyvkLMRW5QSa9Zow.png",
];

export const serviceOptions = [
  "AC Repair",
  "AC Service / Cleaning",
  "AC Installation",
  "Appliance Repair",
  "Sale & Purchase",
  "Appliance Rental",
  "Other Requirement",
];

export const serviceAreas = ["Dwarka Mor", "Uttam Nagar", "Mohan Garden", "West Delhi"];